export const siteMap = {
  "pages": [
    {
      "path": "/",
      "title": "./"
    },
    {
      "path": "/cv",
      "title": "CV"
    },
    {
      "path": "/tech",
      "title": "Tech"
    },
    {
      "path": "/chat",
      "title": "Chat"
    }
  ] as {title: string, path: string}[],
  "lists": {
    "articles": [
      {
        "path": "/designing-fursuit",
        "title": "Designing Fursuit"
      },
      {
        "path": "/headings",
        "title": "Headings"
      },
      {
        "path": "/hybrid_ssg_spa",
        "title": "Hybrid Ssg Spa"
      },
      {
        "path": "",
        "title": "Articles"
      },
      {
        "path": "/test-list-2",
        "title": "Test List 2"
      },
      {
        "path": "/test-list",
        "title": "Test List"
      },
      {
        "path": "/test",
        "title": "Test"
      }
    ] as {title: string, path: string}[],
    "resume": [
      {
        "path": "",
        "title": "Resume"
      }
    ]
  }
}